
import React, { useEffect } from "react";
import "./ContactForm.css";

const ContactForm = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://js-na2.hsforms.net/forms/embed/242675213.js";
    script.defer = true;

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="audit-section">
      <div className="audit-container">

        {/* LEFT */}
        <div className="audit-left">

          <div className="audit-eyebrow">
            FREE AUDIT
          </div>

          <h2>
            Get a free <span>account audit</span>
          </h2>

          <p className="audit-description">
            We will analyze your active Google Ads campaigns, identify wasted
            spend, and deliver a detailed growth blueprint to lower your cost
            per booked job.
          </p>

          <div className="audit-benefits">

            <div className="audit-benefit">
              <div className="check-icon">✓</div>
              <div>
                <strong>48-hour turnaround</strong>
                <span>
                  Get your audit without the long wait.
                </span>
              </div>
            </div>

            <div className="audit-benefit">
              <div className="check-icon">✓</div>
              <div>
                <strong>No obligation</strong>
                <span>
                  You keep the audit either way.
                </span>
              </div>
            </div>

            <div className="audit-benefit">
              <div className="check-icon">✓</div>
              <div>
                <strong>Actionable growth insights</strong>
                <span>
                  Get clear recommendations you can actually implement.
                </span>
              </div>
            </div>

            <div className="audit-benefit">
              <div className="check-icon">✓</div>
              <div>
                <strong>100% transparent analysis</strong>
                <span>
                  See what's working, what's wasting budget, and what to improve.
                </span>
              </div>
            </div>

          </div>
        </div>

        {/* FORM */}
        <div className="audit-form-wrapper">

          <div className="form-header">

            <div className="form-header-icon">
              ↗
            </div>

            <div>
              <h3>Request your free audit</h3>
              <p>
                Tell us a little about your business.
              </p>
            </div>

          </div>

          <div className="hubspot-form-container">

            {/* NEW HUBSPOT FORM */}
            <div
              className="hs-form-frame"
              data-region="na2"
              data-form-id="f257709e-98d3-4932-998c-05b85055746b"
              data-portal-id="242675213"
            ></div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default ContactForm;

